import React, { useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useStoreDispatch, useStoreSelector } from "../../../../../hooks/StoreHooks";
import { FrmImpostazioniIniziali, FrmImpostazioniInizialiHandle } from "./components/forms/frm_impostazioni_iniziali";
import { useDialogs } from "../../../../providers/dialogs_provider";
import { InstallationType, ModuleType } from "./components/forms/Pergola_type";
import { setStepVisible, usePergolaConfigurationBuilderActions } from "../../../../../store/reducers/pergola_configuration_builder";
import { getCurrentUser } from "../../../../core/common_functions";
import { useConfigurationsService } from "../../../../services/configurations_service";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";
import { MuroPergola, Pilastri } from "../../../../models/pergola_configuration";

// Definizione tipo per dialogOptions
type DialogOption = {
  isSelected?: boolean;
};

export const DimensionsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const {base, pergolaConfigurationBuilder } = useStoreSelector((store) => store);
  const dialogs = useDialogs();
  const dispatcher = useStoreDispatch();
  const configurationService = useConfigurationsServicePergola();
  const { setStepActive, setStepComplete,setModuliLarghezza,setModuliProfondita } = usePergolaConfigurationBuilderActions();
  const [isSubmit, setSubmit] = useState<boolean>(false);
  const [dialogOptions, setDialogOptions] = useState<DialogOption[] | null>(null);
  const theme = useTheme();
  const currentUser = getCurrentUser(base);
  const formRef = useRef<FrmImpostazioniInizialiHandle | null>(null);
  
  const submit = async () => {
    try {
      await formRef.current?.checkFields();

      if (formRef.current?.isPatioMultiModulo()) {
        dialogs?.showWarning(
          "Attenzione",
          "Per configurazioni Patio con più moduli è necessario richiedere la fattibilità in azienda."
        );
        return;
      }

      const data = formRef.current?.getFormData();
      const data2 : {pilastri: Pilastri[]} = {pilastri: formRef.current?.getPilastriData() ?? []};
      const h1 = data2.pilastri.find(p => p.direzione === "H1")?.altezza ?? 0;
      const h2 = data2.pilastri.find(p => p.direzione === "H2")?.altezza ?? 0;
      const h3 = data2.pilastri.find(p => p.direzione === "H3")?.altezza ?? 0;
      const h4 = data2.pilastri.find(p => p.direzione === "H4")?.altezza ?? 0;
      if (
          (Math.abs(h1 - h2) > 135 && Math.abs(h1 - h4) > 135) ||
          (Math.abs(h2 - h3) > 135 &&  Math.abs(h2 - h1) > 135) ||
          (Math.abs(h3 - h2) > 135 &&  Math.abs(h3 - h4) > 135) ||
          (Math.abs(h4 - h3) > 135 &&  Math.abs(h4 - h1) > 135)
      ) {
        if (dialogs && typeof dialogs.showWarning === "function") {
          dialogs.showError('warning',"Dislivello maggiore di quello consentito fare una configuazione Pergola Fuori Squadro");
          return;
        } else {
          console.warn("Dialogs non disponibile o metodo show non definito");
        }
      }
      const data3 : {muri: MuroPergola[]} = {muri: pergolaConfigurationBuilder.muri};
      setDialogOptions([{ isSelected: false }]);
      setSubmit(true);
      if (pergolaConfigurationBuilder.configuration && data && data2) {
        let nstacchi = Math.floor(data?.larghezza/1000 / 4.1);
        const tolleranza = 1e-9;
        
        if (Math.abs(nstacchi * 4.1 - data?.larghezza/1000) > tolleranza) {
            nstacchi += 1;
        }
        let nstacchiy = Math.floor(data?.profondita/1000 / 7) ;
        if (Math.abs(nstacchiy * 7 - data?.profondita/1000) > tolleranza) {
            nstacchiy += 1;
        }
        if(pergolaConfigurationBuilder.configuration?.dimensioni.installazione === InstallationType.patio  && !(nstacchiy>1 || nstacchi>1)){
            dispatcher(setStepVisible({ stepSlug: "fioriere",  isVisible: false}));
            dispatcher(setStepActive({ stepSlug: "fioriere", isActive: false }));
        }else{
          dispatcher(setStepVisible({ stepSlug: "fioriere",  isVisible: true}));
        }
        dispatcher(setModuliLarghezza(nstacchi));
        dispatcher(setModuliProfondita(nstacchiy));
        await configurationService.updateDimensionsPergola(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data
        );
        await configurationService.updatePilastri(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data2
        );
        await configurationService.updateMuri(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data3
        );
      }
      dispatcher(setStepComplete({ stepSlug: "dimensioni", isComplete: true }));
      dispatcher(setStepActive({ stepSlug: "aspetto", isActive: true }));
    } catch (err: any) {
      if (dialogs && typeof dialogs.showWarning === "function") {
        dialogs.showWarning('warning',err.message);
      } else {
        console.warn("Dialogs non disponibile o metodo show non definito");
      }
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatcher(setStepActive({ stepSlug: "dimensioni", isActive: true }));
    }
  }, []);

  return (
    <>
      <div className="row m-0 h-full">
        <div>
          <div className="p-4">
            <h5 className="text-primary">Nuova configurazione </h5>
            <FrmImpostazioniIniziali ref={formRef} />
            <div className="d-flex flex-row-reverse justify-content-between mt-3">
              <Button disabled={isSubmit} variant="contained" className="ps-3 pe-1" onClick={submit}>
                <span>Avanti</span>
                <NavigateNextIcon />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
